import BreadcrumbsContainer from '../../containers/common/breadcurmbs/BreadcrumbsContainer';
import IndividualSalaryAndMajorInsureInputContainer from '../../containers/individual-salary-input/IndividualSalaryAndMajorInsureInputContainer';

const IndividualSalaryInputPage = () => {
  return (
    <>
      <BreadcrumbsContainer
        title="판관비 관리/개인별 급여와 4대보험 입력"
        icon="budget"
      />
      <IndividualSalaryAndMajorInsureInputContainer />
    </>
  );
};

export default IndividualSalaryInputPage;
